import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { STAFF_ROLES } from '../redux/selectors';

const STAFF_ALLOWLIST = {
  'Fee Entry': ['/clients', '/invoices', '/ledger', '/account', '/help', '/search'],
  'Billing Viewer': ['/clients', '/invoices', '/ledger', '/account', '/help', '/search'],
  'Receiving Clerk': [
    '/clients',
    '/purchases',
    '/asn',
    '/shipments',
    '/account',
    '/help',
    '/search',
  ],
  'Fulfillment Staff': ['/clients', '/orders', '/account', '/help', '/search'],
  'Warehouse Staff': [
    '/clients',
    '/orders',
    '/purchases',
    '/asn',
    '/shipments',
    '/owner/inventory',
    '/account',
    '/help',
    '/search',
  ],
};

const STAFF_HOME = {
  'Fee Entry': '/invoices',
  'Billing Viewer': '/invoices',
  'Receiving Clerk': '/purchases',
  'Fulfillment Staff': '/orders',
  'Warehouse Staff': '/orders',
};

export const pathMatchesRoutePrefix = (pathname, prefix) =>
  pathname === prefix || pathname.startsWith(`${prefix}/`);

const StaffRouteGuard = ({ user, children }) => {
  const location = useLocation();

  if (!STAFF_ROLES.includes(user.role)) {
    return children;
  }

  const allowed = STAFF_ALLOWLIST[user.role] ?? [];
  const isAllowed = allowed.some((prefix) => pathMatchesRoutePrefix(location.pathname, prefix));

  if (!isAllowed) {
    return <Navigate to={STAFF_HOME[user.role] ?? '/orders'} replace />;
  }

  return children;
};

export { STAFF_HOME };
export default StaffRouteGuard;
